import { render, staticRenderFns } from "./OrnamentHistory.vue?vue&type=template&id=6e657de6&scoped=true&"
import script from "./OrnamentHistory.vue?vue&type=script&lang=js&"
export * from "./OrnamentHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrnamentHistory.vue?vue&type=style&index=0&id=6e657de6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e657de6",
  null
  
)

export default component.exports